import { useScopedQuery } from "@/hooks/use-scoped-query";
import { notificationSettingsQuery } from "@/queries/notification-settings";
import { useStore } from "@/stores/store-context";
import type { INotificationSetting } from "@/types/user";

/**
 * The signed-in user's notification switches in `workspaceSlug`
 * (`app/queries/notification-settings.ts`): `undefined` until they load.
 * `loadFailed` is a failed read with nothing to show; the cache logs it.
 *
 * Must be called from an `observer` component.
 */
export function useNotificationSettings(workspaceSlug: string | undefined): {
  settings: INotificationSetting[] | undefined;
  loadFailed: boolean;
} {
  const { userService } = useStore();
  const { query } = useScopedQuery(
    workspaceSlug,
    (scope) => notificationSettingsQuery(userService, scope),
    { flag: null },
  );
  return { settings: query.data, loadFailed: query.isError && query.data === undefined };
}
